import styled from "@emotion/styled";
import { BeatHorizontalCard } from "@evt/beat";

export const CardRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-evenly;
  margin-bottom: 24px;
  width: 100%;
`;


export const CardColumn = styled.div`
  display: flex;
  flex-direction: column;
`;

export const BeatHorizontalCardCustom = styled(BeatHorizontalCard)`
  max-width: 400px !important;
`;